import { getUSFormatDate, convertKebabCaseDateString } from 'utils';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  data: {
    netSales: {},
    wardrobing: {},
    clientConnect: {},
    averageTrip: {},
    averageTripPerCustomer: {},
  },
  totalScore: 0,
  validThrough: '',
};

export const updateScorecardDetails = ({ data, categories = '' }, currentState) => {
  const categoryTypes =
    categories && typeof categories === 'string' ? categories.split(',') : Object.keys(currentState);

  const filteredCategories = Object.keys(data).reduce((acc, curr) => {
    if (categoryTypes.includes(curr)) {
      acc[curr] = data[curr];
    }

    return acc;
  }, {});

  return {
    ...currentState,
    ...filteredCategories,
  };
};

const expandedScorecardReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.ASSOCIATE_EXP_SCORECARD_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.ASSOCIATE_EXP_SCORECARD_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.ASSOCIATE_EXP_SCORECARD_CLEAR:
      return {
        ...INITIAL_STATE,
      };
    case actionTypes.ASSOCIATE_EXP_SCORECARD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: updateScorecardDetails(payload, state.data),
        totalScore: typeof payload.data.overAllScore === 'number' ? Math.round(payload.data.overAllScore) : 'N/A',
        validThrough: payload.data.validThrough
          ? getUSFormatDate(convertKebabCaseDateString(payload.data.validThrough))
          : '',
      };

    default:
      return state;
  }
};

export default expandedScorecardReducer;
